export default [
    {
        path: 'task/OnceTaskCreator',
        component: () => import('@/views/task/components/OnceTaskCreator'),
        name: 'OnceTaskCreator',
        meta: { title: '创建任务', icon: 'a-up', noCache: false },
        hidden: true
    },

]
